/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const styles = () => ({
  actionsRoot: {
    justifyContent: 'space-between',
    margin: '10px',
  },
});

class ConfirmationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  handleClose = () => {
    this.props.onClose();
  };

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.props.onClose();
  };

  handleOk = () => {
    const promise = this.props.onConfirm();
    if (promise) {
      this.setState({ isLoading: true });
      promise.finally(() => {
        this.setState({ isLoading: false });
      });
    }
  };

  render() {
    const { open, loading, classes, confirmButtonColor } = this.props;
    const { isLoading } = this.state;
    const isMyLoading = isLoading || loading;
    return (
      <Dialog
        maxWidth="xs"
        onClose={this.handleClose}
        aria-labelledby="confirmation-dialog-title"
        open={open}
      >
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent>
          <Typography component="div">{this.props.message}</Typography>
        </DialogContent>
        <DialogActions className={classes.actionsRoot}>
          <Button onClick={this.handleCancel} color="primary" disabled={isMyLoading} variant="outlined">
            Cancelar
          </Button>
          <Button
            onClick={this.handleOk}
            color={confirmButtonColor}
            disabled={isMyLoading}
            variant="contained"
          >
            {this.props.confirmText}
            {isMyLoading && <CircularProgress size={12} />}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ConfirmationDialog.defaultProps = {
  onCancel: null,
  confirmText: 'Sim',
  confirmButtonColor: 'primary',
};
ConfirmationDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  confirmText: PropTypes.string,
  confirmButtonColor: PropTypes.string,
};
export default withStyles(ConfirmationDialog, styles);
